/**
 * @desc 根据爬虫任务ID终止爬虫任务
 */
const URL = "/rantion-crawler";
import http, { updateResponse } from "@/http";
export function request(id: string | number, options?: any) {
  return updateResponse(
    http(URL + `/crawlerTask/terminate/${id}`, {
      method: "POST",

      ...options,
    }),
  );
}
